module.exports = __webpack_public_path__ + "static/media/check.03a47f6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/check.svg
// module id = 480
// module chunks = 0